import { v4 as uuidv4 } from 'uuid';

import { EventAssociatedModel, EventPost } from '~/types/adamTypes';

export type UseAppEventPost = {
  init: () => void;
  release: () => void;
};

export const useAppEventPost = (
  pCategory: CategorySchema | Ref<CategorySchema>,
  pDisciplineId: string | Ref<string>,
  pPost: PostSchema | Ref<PostSchema>
): UseAppEventPost => {
  const category = toValue(pCategory);
  const disciplineId = toValue(pDisciplineId);
  const post = toValue(pPost);

  const sessionStore = useSessionStore();

  const visitSessionId = ref<string>(uuidv4());
  let dateStart = new Date();

  if (!post) {
    throw new Error('useAppEventPost : post not loaded');
  }

  const { query } = useRoute();

  const { createEvent } = useAppEvent(
    EventAssociatedModel.Post,
    post.id,
    post.libraryBookId
  );

  const getTimeSpent = () => {
    return Math.ceil((new Date().getTime() - dateStart.getTime()) / 1000);
  };

  const getEventData = () => {
    const eventData: any = {};
    eventData.VisitSessionId = visitSessionId.value;

    return eventData;
  };

  const visited = async () => {
    const eventData = getEventData();
    eventData.Discipline = disciplineId;
    eventData.ParentType = category.contentType;
    eventData.ParentId = category.id;
    eventData.ContentType = post.contentType;
    eventData.WorkingSessionId = sessionStore.id;

    if (query.QuestionId && query.QuizSessionId) {
      eventData.QuestionId = query.QuestionId;
      eventData.QuizSessionId = query.QuizSessionId;
    }

    await createEvent(EventPost.Visited, eventData, true);
  };

  const ended = async () => {
    const eventData = getEventData();
    eventData.TimeSpentReadingPost = getTimeSpent();

    await createEvent(EventPost.Ended, eventData);
  };

  const release = () => {
    ended();
  };

  const init = () => {
    visited();
  };

  watch(
    () => sessionStore.started,
    (isStarted) => {
      if (isStarted) dateStart = new Date();
    }
  );

  return {
    init,
    release,
  };
};
